import { MapUtils } from '../../utility/map-utils.js';
import { cloneData, DataModel, DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../dto/dto.js';
import { LocalizedRichDescription } from './localized-rich-description.js';

export class Consent extends DataModel {
  static readonly TYPE_ID: string = '6f402c46437e45c8b77917d985695340';

  private constructor(
    public readonly localizations: LocalizedRichDescription,
    public readonly enabled: boolean,
    public readonly mandatory: boolean,
  ) {
    super();
  }

  get $typeId() {
    return Consent.TYPE_ID;
  }

  static create(args: {
    localizations: LocalizedRichDescription;
    enabled: boolean;
    mandatory: boolean;
  }): Consent {
    return new Consent(
        args.localizations,
        args.enabled,
        args.mandatory,
    );
  }

  static empty(): Consent {
    return new Consent(LocalizedRichDescription.empty(), false, false);
  }

  static fromMap(context: SerializationContext, map: SerializedData): Consent {
    return new Consent(
        context.fromData<LocalizedRichDescription>(MapUtils.getRecord(map, 'localizations')),
        MapUtils.getBoolean(map, 'enabled'),
        MapUtils.getBoolean(map, 'mandatory'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'localizations': context.toData<LocalizedRichDescription>(this.localizations),
      'enabled': this.enabled,
      'mandatory': this.mandatory,
    };
  }

  clone(): this {
    return new Consent(
        cloneData(this.localizations),
        this.enabled,
        this.mandatory,
    ) as this;
  }

  isSame(other: Consent): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.localizations, this.localizations) &&
      other.enabled === this.enabled &&
      other.mandatory === this.mandatory;
  }
}

export class ConsentBuilder extends DataModelBuilder<Consent> {
  build(context: SerializationContext, map: SerializedData): Consent {
    return Consent.fromMap(context, map);
  }
}
